module.exports = __webpack_public_path__ + "img/digital-ads-performance.ef350f55.svg";